import React from 'react';

const images = Array.from({ length: 12 }, (_, index) => ({
  src: `https://cloud.sharemyimage.com/2026/10/12/${index + 1}.png`,
  alt: `HostFig creative project ${index + 1}`
}));

const VisionCarousel = () => (
  <section className="overflow-hidden bg-white py-14 sm:py-16">
    <style>
      {`
        @keyframes vision-marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .vision-marquee-track {
          animation: vision-marquee 42s linear infinite;
          will-change: transform;
        }
        .vision-marquee:hover .vision-marquee-track,
        .vision-marquee:focus-within .vision-marquee-track {
          animation-play-state: paused;
        }
        @media (prefers-reduced-motion: reduce) {
          .vision-marquee-track {
            animation: none;
          }
        }
      `}
    </style>

    <div className="mx-auto mb-8 max-w-[1248px] px-6 text-center md:px-12 lg:px-24">
      <p className="mb-2 text-xs font-bold uppercase tracking-[0.2em] text-blue-600">
        Made around your ideas
      </p>
      <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
        Your Vision = Our goal
      </h2>
    </div>

    <div
      className="vision-marquee relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]"
      role="region"
      aria-label="A scrolling showcase of creative work"
    >
      <div className="vision-marquee-track flex w-max">
        {[0, 1].map((group) => (
          <div
            key={group}
            aria-hidden={group === 1}
            className="flex shrink-0 gap-4 pr-4 sm:gap-5 sm:pr-5"
          >
            {images.map((image, index) => (
              <div
                key={`${group}-${image.src}`}
                className="h-[190px] w-[260px] shrink-0 overflow-hidden rounded-2xl border border-slate-200 bg-slate-100 shadow-sm sm:h-[250px] sm:w-[340px]"
              >
                <img
                  src={image.src}
                  alt={group === 0 ? image.alt : ''}
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover transition-transform duration-500 hover:scale-105"
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default VisionCarousel;